var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 31.998c8.837 0 16-7.163 16-16 0-8.836-7.163-16-16-16s-16 7.164-16 16c0 8.837 7.163 16 16 16z",
    fill: "#000018",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.56 17.287v6.597h-3.825v-6.155c0-1.545-.552-2.6-1.936-2.6-1.057 0-1.685.71-1.962 1.398-.1.246-.127.587-.127.932v6.424h-3.825s.052-10.423 0-11.502h3.825v1.63c-.007.013-.018.025-.025.038h.025v-.038c.509-.782 1.415-1.9 3.447-1.9 2.516 0 4.403 1.644 4.403 5.176zM9.884 6.837c-1.308 0-2.164.858-2.164 1.987 0 1.104.831 1.988 2.114 1.988h.025c1.334 0 2.163-.884 2.163-1.988-.025-1.129-.829-1.988-2.138-1.988zM7.948 23.883h3.823V12.38H7.948v11.503z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0V0z",
    fill: "#fff"
  })))));
}
export default __webpack_public_path__ + "static/media/linkedin.fe97e765.svg";
export { SvgLinkedin as ReactComponent };